export class PesquisaPropostaDto{
    id: string
    proposta: string
    dataProposta: string
    numeroPAC: string
    dataPAC: string
    comprador: string
    fabricante: string
    programa: string
    codAgenteFinanceiro: string
    siglaAgenteFinanceiro: string
    cnpjAgenteFinanceiro: string;
    entrada: string
    aprovacao: string
    valor: number
    situacao: string
    idPrograma: number;
    idSubPrograma: number;
    documento: string;
    situacaoN03: string;
}
